var render = function render(){var _vm=this,_c=_vm._self._c;return _c('parameter-router-auth-container',{attrs:{"isInsideDialog":_vm.isInsideDialog,"initialAuthType":_vm.initialAuthType,"id":"checkout-authentication"}})
}
var staticRenderFns = []

export { render, staticRenderFns }